<template>
  <el-dialog title="上传领用明细" :visible.sync="dialogVisible" :close-on-click-modal="false" width="35%" v-loading="loading" @close="close">
    <div class="import-btn">
      <el-button class="btn-grey-plain">
        <a :href="templateFile" target="_blank">下载领用明细模版</a>
      </el-button>
    </div>
    <div class="import-btn">
      <FileUpload
        ref="dataFileUpload"
        :upload-param="{ filePath: 'temp' }"
        show-type="text"
        @uploaded="getDataFile"
        @removed="clearDataFile"
      >
        <el-button class="btn-blue-plain">上传领用明细文档</el-button>
      </FileUpload>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="btn-orange-plain" @click="submitUpload" size="small">确 定</el-button>
      <el-button class="btn-grey" @click="dialogVisible = false" size="small">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import freezerApi from '@/api/freezer'
import FileUpload from '@/components/file-upload'
export default {
  name: 'freezer-import',
  data () {
    return {
      dialogVisible: false,
      loading: false,
      templateFile: require('@/assets/files/import-freezer-template.xlsx'),
      fileId: ''
    }
  },
  components: {
    FileUpload
  },
  methods: {

    // show
    show () {
      this.dialogVisible = true
      this.fileId = ''
    },

    close () {
      this.$refs.dataFileUpload.clearFileList()
    },

    submitUpload () {
      if (!this.fileId) {
        this.$message.error('请上传领用明细文件')
        return
      }
      let params = {
        dataFileId: this.fileId
      }
      this.loading = true
      freezerApi.importFreezerOrder(params).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.dialogVisible = false
          this.$message.success('领用订单上传成功')
        }
      }).catch(() => {
        this.loading = false
      })
    },

    getDataFile (file) {
      this.fileId = file.fileId
    },

    clearDataFile () {
      this.fileId = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.import-btn {
  text-align: center;
  width: 320px;
  margin: auto;
  &+.import-btn {
    margin-top: $content-middle;
  }
}
</style>
